import PatientDoseSpotActiveMedicationsV1 from "../../../../components/form_builder/elements/patient_dose_spot_active_medications/PatientDoseSpotActiveMedicationsV1.vue";

export default {
  componentName: "fb-patient-dose-spot-active-medications-v1",
  component: PatientDoseSpotActiveMedicationsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Dose Spot Active Medications",
      description: "",
      eFormEditable: false,
      hidden: false,
      dateFilter: "all",
      dependentProperties: {}
    },
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value,
  },
  validate: () => {
    return [];
  },
};
